module.exports = __webpack_public_path__ + "static/media/DRUMS.b8027c98.jpg";